import { useTheme } from './ThemeProvider';
import styles from './ThemeSwatches.module.css';
import { THEMES, THEME_ORDER } from './themes';

const THEME_LABELS: Record<(typeof THEME_ORDER)[number], string> = {
  'sage-teal': 'Sage Teal theme',
  'ember-gray': 'Ember Gray theme',
};

/** The theme-swatch dots — LANE U6 (Jason's palette pick) narrowed this from
 *  three (setPaper / setSage / setDusk in the mockup) to exactly two: Sage
 *  Teal (light) and Ember Gray (dark). Reused on Home's header and the
 *  onboarding welcome step. */
export function ThemeSwatches() {
  const { theme, setTheme } = useTheme();

  return (
    <div className={styles.row}>
      {THEME_ORDER.map((name) => (
        <button
          key={name}
          type="button"
          onClick={() => setTheme(name)}
          aria-label={THEME_LABELS[name]}
          aria-pressed={theme === name}
          className={styles.swatch}
          data-active={theme === name}
          style={{ background: THEMES[name].swatch }}
        />
      ))}
    </div>
  );
}
